module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    staticClass: "manual-img",
    attrs: {
      "src": require("assets/gal_tukaikata.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70ed74fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Manual.vue
// module id = 223
// module chunks = 1